import { CellContext, ColumnDef } from '@tanstack/react-table';
import React from 'react';
import { DeliveryInfoRow } from './deliveryInfoData';
import { useJobDetailsProvider } from '../../../../../../context/jobDetails';
import { Badge } from '../../../../../../../components/Common/UI/Badge';
import { cn } from '../../../../../../../utils/styles';
import { JobDetailColumnType } from '../subTableConfig';

function CounterBadgeAction({ row, column }: CellContext<DeliveryInfoRow, unknown>) {
  const { handleSelectedTable, selectedTable } = useJobDetailsProvider();
  const { getValue, original } = row;

  const handleClick = () => {
    handleSelectedTable({ row: original.duration, column: column.id as JobDetailColumnType });
  };

  const isDisabled = getValue(column.id) === 0 || column.id !== 'percentage';
  const isActiveStyle = selectedTable.row === original.duration && selectedTable.column === column.id;

  return (
    <Badge
      variant={!isDisabled ? 'counter' : 'counterDisabled'}
      onClick={!isDisabled ? handleClick : undefined}
      className={cn('cursor-pointer hover:bg-addition4-10', {
        'bg-addition4-20 hover:bg-addition4-20': isActiveStyle && !isDisabled,
      })}
    >
      {getValue(column.id)}
      {column.id === 'percentage' ? '%' : null}
    </Badge>
  );
}

// Paper/Both!
export const deliveryInfoCol: ColumnDef<DeliveryInfoRow>[] = [
  {
    accessorKey: 'duration',
    header: 'Duration',
    cell: ({ row }) => (
      <span className="text-xs font-medium tracking-widest uppercase">{row.getValue('duration')}:</span>
    ),
  },
  {
    accessorKey: 'percentage',
    header: 'Percentage',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'complete',
    header: 'Complete',
    cell: CounterBadgeAction,
  },
];

export default deliveryInfoCol;
